























































import { Component, Vue } from 'vue-property-decorator';
import { emailApis, MailingListRecord } from '@/api/email.api';

@Component
export default class RemoveMembersDialog extends Vue {
  dialogVisible = false;
  currentList: MailingListRecord | null = null;
  selectedMembers: string[] = [];
  submitting = false;
  searchQuery = '';
  selectAll = false;

  get filteredMembers(): string[] {
    if (!this.currentList) return [];
    if (!this.searchQuery) return this.currentList.members;
    return this.currentList.members.filter(member => member.toLowerCase().includes(this.searchQuery.toLowerCase()));
  }

  get isIndeterminate(): boolean {
    const selectedCount = this.selectedMembers.filter(m => this.filteredMembers.includes(m)).length;
    return selectedCount > 0 && selectedCount < this.filteredMembers.length;
  }

  open(listRecord: MailingListRecord) {
    this.currentList = { ...listRecord };
    this.selectedMembers = [];
    this.searchQuery = '';
    this.selectAll = false;
    this.dialogVisible = true;
  }

  handleClose() {
    this.dialogVisible = false;
    this.currentList = null;
    this.selectedMembers = [];
    this.searchQuery = '';
    this.selectAll = false;
  }

  handleSelectAll(value: boolean) {
    if (value) {
      // 全选：添加所有过滤后的成员到选中列表
      const toAdd = this.filteredMembers.filter(m => !this.selectedMembers.includes(m));
      this.selectedMembers = [...this.selectedMembers, ...toAdd];
    } else {
      // 取消全选：从选中列表中移除所有过滤后的成员
      this.selectedMembers = this.selectedMembers.filter(m => !this.filteredMembers.includes(m));
    }
  }

  async handleSubmit() {
    if (!this.currentList || this.selectedMembers.length === 0) {
      return;
    }

    try {
      await this.$confirm(`确定要删除选中的 ${this.selectedMembers.length} 个成员吗？`, '删除成员确认', {
        type: 'warning'
      });
    } catch {
      return;
    }

    try {
      this.submitting = true;
      await emailApis.mailingListsModify(this.currentList.name, {
        action: 'removeItem',
        members: this.selectedMembers
      });
      this.$message.success('删除成员成功');
      this.$emit('success');
      this.handleClose();
    } catch (error) {
      this.$message.error(`删除成员失败: ${error.message || error}`);
    } finally {
      this.submitting = false;
    }
  }
}
